<template>
    <div class="w_inner">
          <div class="w_contact_con w">
            <div class="contact_box wow fadeIn animated" data-wow-delay="0.2s">
              <template v-if="contactList[current_index]">
              <div class="item">
                <img class="logo" src="../assets/images/contact_tel.png" />
                <span class="text">{{$t('contact.phone')}}：{{currentLang=='zh'? contactList[current_index].phone:contactList[current_index].enphone}}</span>
              </div>
              <div class="item">
                <img class="logo" src="../assets/images/contact_email.png" />
                <span class="text">{{$t('contact.email')}}：{{currentLang=='zh'? contactList[current_index].email:contactList[current_index].enemail}}</span>
              </div>
              <div class="item">
                <img class="logo" src="../assets/images/contact_mobile.png" />
                <span class="text">TEL：{{currentLang=='zh'? contactList[current_index].tel:contactList[current_index].entel}}</span>
              </div>
              <div class="item">
                <img class="logo" src="../assets/images/contact_fax.png" />
                <span class="text">{{$t('contact.fax')}}：
                  {{currentLang=='zh'? contactList[current_index].fax:contactList[current_index].enfax}}
                </span>
              </div>
              </template>
            </div>

            <div class="contact_map" v-if="contactList.length>0">
              <div class="big_title wow fadeInUp animated"  data-wow-delay="0.2s">{{$t('contact.navigation')}}</div>
              <div class="map_list clearfix">
                <div class="left wow fadeInLeft animated" data-wow-delay="0.3s">
                  <template v-for="(item,index) in contactList">
                    <div class="item" :key="index" @click="ClickMap(item,index)" :style="'cursor: pointer;'+(current_index==index?'background-color:rgb(241,205,185,.3);padding:10px;':'')">
                      <div v-if="currentLang=='zh'" class="company_name">{{item.name}}</div>
                      <div v-else class="company_name">{{item.enname}}</div>
                      <div v-if="currentLang=='zh'" class="address">{{item.address}}</div>
                      <div v-else class="address">{{item.enaddress}}</div>
                    </div>
                 </template>
                  
                </div>
                <div class="right wow fadeInRight animated" data-wow-delay="0.3s">
                  <viewer>
                      <img v-if="currentLang=='zh'" :src="contactList[current_index].img" />
                      <img v-else :src="contactList[current_index].enimg" />
                  </viewer>
                </div>
              </div>
            </div>

          </div>

    </div>
</template>

<script>
import {mapState} from 'vuex'
import WOW from "../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      contactList:[],
      current_index:0,
      currentLang:this.$i18n.locale
    }
  },
  computed:{
    ...mapState({
      CompanyInfo:state=>state.CompanyInfo
    })
  },
  created: function () {
      this.HandleInfo();
  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
  
  },
  components: {
    
  },
  methods: {
     HandleInfo(){
      if (this.CompanyInfo.contactList){
        this.contactList = JSON.parse(this.CompanyInfo.contactList);
        //console.log(this.contactList);
      }
     },
     ClickMap(item,index){
      this.current_index=index;
     }
  },
  watch:{
    CompanyInfo(){
      this.HandleInfo();
    }
  }
};
</script>
